module.exports = " <div> <ly-header></ly-header> <ly-nav></ly-nav> <div class=content> <ol class=breadcrumb> <li v-for=\"el in $route.parent\"> <a href=#!{{el.uri}} title={{el.title}} v-if=\"el.uri != undefined\">{{el.title}}</a> <span v-else>{{el.title}}</span> </li> <li class=active>{{$route.title}}</li> </ol> <router-view></router-view> <div id=page-404 v-if=!isPage></div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
 ** module id = 44
 ** module chunks = 0
 **/